import React, { Dispatch, SetStateAction } from "react";
import { CorrectIcon } from "../Icon/CorrectIcon";
import "./index.scss";

interface IProps {
  onChange: Dispatch<SetStateAction<boolean>>;
  checked: boolean;
}

export const CheckBox = ({ onChange, checked }: IProps) => {
  const handleChecked = () => {
    onChange((prev) => !prev);
  };
  return (
    <div className="check-box-wrapper" onClick={handleChecked}>
      {checked && <CorrectIcon />}
    </div>
  );
};
